import * as yup from "yup";

const authSchema = yup.object({
  cpf: yup
    .string()
    .matches(/\d{11}/, "CPF inválido")
    .required("CPF obrigatório"),
  password: yup.string().required("Senha obrigatória").trim(),
});

export default authSchema;
